import { render } from "./SearchPatient.vue?vue&type=template&id=7a261770"
import script from "./SearchPatient.vue?vue&type=script&lang=js"
export * from "./SearchPatient.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__